import React from "react";
import { t } from "ttag";

interface IOwnProps {}

type IProps = IOwnProps;

interface IState {}

// TODO(ssr, VERY_LOW 2 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 2/10 due to simple scroll handler and no state or lifecycle methods.
export class FlagshipReviewsLink extends React.Component<IProps, IState> {
    private readonly onScrollToReviews = (
        event: React.MouseEvent<HTMLElement>,
    ) => {
        if (event) {
            event.preventDefault();
        }
        const reviews = document.querySelector("#reviews");
        reviews?.scrollIntoView({ behavior: "smooth" });
    };

    render() {
        return (
            <button
                className="pullquote__link scroll-on-page-link"
                onClick={this.onScrollToReviews}
            >
                {/* TODO(i18n): Include HTML entity in translation string to keep punctuation together: {t`See More Testimonials \u00BB`} */}
                {t`See More Testimonials`} &#187;
            </button>
        );
    }
}
